module.exports = __webpack_public_path__ + "static/media/stat547u_lecture11.f47d2630.pdf";